const TEXT_REPLACEMENTS: Array<[RegExp, string]> = [
  [/\u00e2\u201a\u00ac/g, 'EUR'],
  [/\u00e2\u20ac[\u201c\u201d]/g, '-'],
  [/\u00e2\u20ac\u02dc/g, "'"],
  [/\u00e2\u20ac\u2122/g, "'"],
  [/\u00e2\u20ac\u0153/g, '"'],
  [/\u00e2\u20ac[\u009d\ufffd]/g, '"'],
  [/\u00e2\u20ac\u00a6/g, '...'],
  [/\u00e2\u20ac\u00a2/g, '-'],
  [/\u00c2\u00b7/g, ' - '],
  [/\u00c2\u00a0/g, ' '],
  [/\u00c2/g, ''],
  [/\u20ac/g, 'EUR'],
  [/\u2013|\u2014/g, '-'],
  [/\u2018|\u2019/g, "'"],
  [/\u201c|\u201d/g, '"'],
  [/\u2026/g, '...'],
  [/\u2022/g, '-'],
  [/\ufffd/g, ''],
];

function isTimestampLike(value: Record<string, unknown>) {
  return (
    typeof value.toMillis === 'function' ||
    typeof value.toDate === 'function' ||
    (typeof value.seconds === 'number' && typeof value.nanoseconds === 'number')
  );
}

export function repairTextArtifacts(value: string) {
  let next = value;
  for (const [pattern, replacement] of TEXT_REPLACEMENTS) {
    next = next.replace(pattern, replacement);
  }
  return next
    .replace(/[ \t]{2,}/g, ' ')
    .replace(/[ \t]+([,.;:!?])/g, '$1')
    .replace(/\s+-\s+/g, ' - ');
}

export function repairTextArtifactsInValue<T>(value: T): T {
  if (typeof value === 'string') return repairTextArtifacts(value) as T;
  if (Array.isArray(value)) return value.map((item) => repairTextArtifactsInValue(item)) as T;
  if (value && typeof value === 'object') {
    if (value instanceof Date || isTimestampLike(value as Record<string, unknown>)) return value;
    return Object.fromEntries(
      Object.entries(value as Record<string, unknown>).map(([key, item]) => [key, repairTextArtifactsInValue(item)]),
    ) as T;
  }
  return value;
}
